export const ACCOUNT_EXISTS_MESSAGE = 'An account with this email address already exists. If you have forgotten your password, click the ‘Reset your password’ link below';
export const CONTACT_US_MESSAGE = 'Sorry, you’ll need to contact us to set up your online account.';
